export default {
      id: "ge-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#ge",
      toString: function () {
        return this.url;
      }
    }